import { Component, Inject } from '@angular/core';
import { SDS_DIALOG_DATA, SdsDialogRef } from '@gsa-sam/components';
import { AccountDetailsService } from '../../../service/account-details/account.details.service';

@Component({
  selector: 'sam-otp-modal',
  templateUrl: './otp-modal.component.html',
  styleUrls: ['./otp-modal.component.scss'],
})
export class OTPModalComponent {
  oneTimePassword = '';
  errorMessage = '';
  constructor(
    public dialogRef: SdsDialogRef<OTPModalComponent>,
    @Inject(SDS_DIALOG_DATA) public data: any,
    private accountDetailsService: AccountDetailsService
  ) { }

  onNoClick() {
    this.dialogRef.close();
  }

  onSubmit() {
    if (this.oneTimePassword) {
      if (this.data?.removeOtp) {
        const result = {
          otp: this.oneTimePassword
        };
        this.dialogRef.close(result);
      } else {

        this.accountDetailsService.getOtp(this.oneTimePassword).subscribe({
          next: (data) => {
            const result = {
              data: null,
              otp: this.oneTimePassword
            };
            if (data) {
              result.data = Array.isArray(data) ? data : [data];
            }
            this.dialogRef.close(result);
          },
          error: () => {
            this.errorMessage = 'Password verification failed.';
          },
        });
      }
    }
  }

  onSendNewCode() {
    this.errorMessage = '';
    this.accountDetailsService.sendOtp().subscribe();
  }
}
